export default "__VITE_ASSET__BpwUZMrx__"